import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      alignItems: 'center',
      backgroundColor: COLORS.neutral.white,
    },
    layout: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-around',
      flex: '1 1!important',
    },
    wrapper: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      width: '100%',
    },
    logo: {
      position: 'absolute',
      left: theme.spacing(3),
      top: theme.spacing(3),

      '& svg': {
        fontSize: theme.typography.pxToRem(27),
      },
    },
    oauthLabel: {
      '&:before, &:after': {
        width: '26%',
      },
    },
    form: {
      alignSelf: 'stretch',
    },
    agreement: {
      position: 'absolute',
      bottom: 0,
      marginBottom: theme.spacing(2),
      padding: theme.spacing(0, 6),
      textAlign: 'center',
    },
    rightPanel: {
      flexShrink: 0,
    },
  }),
  { name: 'SignUpPage' }
);
